/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
const recordsPerPage = 20000;

import {db} from '../firebase';
import _ from 'lodash';
import search_config from "../search"


export default new Vuex.Store({
	state : {
		// manage locations state here
		// so the filtering persists across views
		filters : {
			criterion: 'all', // can be 'city', 'state', 'postalCode'
			searchTerm : ''
		},
		sections: {
			reports : {
				read: false,
				write: false
			},
			offer: {
				read: false,
				write: false
			},
			localbusiness: {
				read: false,
				write: false
			}
		},
		notification : false,
		authenticated : false,
		accessToken: '',
		firebaseData: {},
		firebaseDataMap: {},
		firebaseDataStatus: {},
    filteredData: {},
    dataPagination: {},
		activeTab : '',
		clientId : '',
    organization: {},
    linked_organizations: {},
    currentLocation: {},
    searchIndex:{},
    addItemToSearch:{},
		searchConfig: search_config,
		searchText: '',
	savingId: null,
	publishingStates: {}
	},
	getters : {
		// filtered locations is computed based on current filters
		// original locations can be updated without filter criteria being destroyed
		accessToken: state => {
			return state.accessToken;
		},
		searchIndex: state => (firebaseNode) => {
      return state.searchIndex[firebaseNode];
		},
		searchConfig: state => (firebaseNode, criterion) => {
      return state.searchConfig.queryConfig[firebaseNode][criterion];
		},
		searchText: state => {
			return state.searchText;
		},
    criterion: state => {
		  return state.filters.criterion;
    },
		firebaseData: state => (firebaseNode) => {
			if (!Array.isArray(state.firebaseData[firebaseNode])) {
	  		state.firebaseData[firebaseNode] = []
	  	}
      return state.firebaseData[firebaseNode];
    },
    firebaseDataMap: state => (firebaseNode) => {
			if (state.firebaseDataMap[firebaseNode] == null) {
	  		state.firebaseDataMap[firebaseNode] = {}
	  	}
	    return state.firebaseDataMap[firebaseNode];
    },
    firebaseDataStatus: state => (firebaseNode) => {
    	if (state.firebaseDataStatus[firebaseNode] == null) {
	  		state.firebaseDataStatus[firebaseNode] = 'NOT LOADED'
	  	}
    	return state.firebaseDataMap[firebaseNode];
    },

    dataPagination: state => (firebaseNode) => {
    	if (state.dataPagination[firebaseNode] == null) {
	  		state.dataPagination[firebaseNode] = {currentPage: 0}
	  	}
		  return state.dataPagination[firebaseNode]
    },

    organization: state => {
		  return state.organization;
    },
    linked_organizations: state => {
		  return state.linked_organizations;
	},
	isPublishingData: (state) => (type) => {
		return type in state.publishingStates
	}
	},
	mutations : {
		changeDataStatus: function(state, payload) {
			let firebaseNode = payload.firebaseNode
			let status = payload.status
			state.firebaseDataStatus[firebaseNode] = status
		},
		initSearchIndex: function(state, payload) {
				let firebaseNode = payload.firebaseNode
				state.searchIndex[firebaseNode] = state.searchConfig.initIndex(firebaseNode)
				if (firebaseNode === 'LocalBusinesses') {
					console.log('PLACE_COMPONENT INDEX LOADED')
					state.searchIndex['PLACE_COMPONENT'] = state.searchConfig.initIndex('PLACE_COMPONENT')
				}
		},
		setSavingId: function(state, savingId) {
			console.log("setSavingId(" + savingId + ")")
	    state.savingId = savingId;
    },
		addItemToSearch: function (state, payload) {
			let firebaseNode = payload.firebaseNode
			let item = payload.item
			state.searchConfig.indexFunction[firebaseNode](item, state.searchIndex[firebaseNode])
			if (firebaseNode === 'LocalBusinesses') {
				state.searchConfig.indexFunction['PLACE_COMPONENT'](item, state.searchIndex['PLACE_COMPONENT'])
			}
	},
		setAccessToken: function(state, token) {
			state.accessToken = token;
	},
	setOrg: function(state, org) {
	    state.organization = org;
    },
    setLinkedOrgs: function(state, orgs) {
	    state.linked_organizations = orgs;
    },
		updateSectionPermits: function(state, val) {
			state.sections[val.section] = val.permits
		},
		updateAllSectionPermits: function(state, allPermits) {
			state.sections = allPermits
		},
		// set filters
		updateFilter : function(state, searchTerm){
			state.filters.searchTerm = searchTerm;
		},
		updateData : function(state, payload) {
			let firebaseNode = payload.firebaseNode
    	let items = payload.items
			state.firebaseData[firebaseNode] = items;
		},
    updateSearchCriterion: function(state, criterion) {
		  state.filters.criterion = criterion;
		},
		updateSearchText: function(state, text) {
		  state.searchText = text;
    },
    createDataCache: function(state, payload) {
    	let firebaseNode = payload.firebaseNode
    	let callback = payload.callback
    	if (!Array.isArray(state.firebaseData[firebaseNode])) {
	  		state.firebaseData[firebaseNode] = []
	  	}
	  	callback(state.firebaseData[firebaseNode])
    },
    appendItems: function(state, payload) {
    	let firebaseNode = payload.firebaseNode
    	let items = payload.items
    	let callback = payload.callback

			if (!Array.isArray(state.firebaseData[firebaseNode])) {
	  		state.firebaseData[firebaseNode] = []
	  	}
	  	if (state.firebaseDataMap[firebaseNode] == null) {
	  		state.firebaseDataMap[firebaseNode] = {}
	  	}

	  	items.forEach((item) => {
	  		if (state.firebaseDataMap[firebaseNode][item.id] == null) {
	  			state.firebaseData[firebaseNode].push(item);
	  			state.firebaseDataMap[firebaseNode][item.id] = item
	  		} else if ( item.id === state.savingId && state.savingId != null) {
	  			let idx = state.firebaseData[firebaseNode].findIndex( (el, index, array) => {
	  					if (el.id == item.id) {
	  						return true
	  					}
	  					return false
	  			})
	  			state.firebaseData[firebaseNode][idx] = item
	  			state.firebaseDataMap[firebaseNode][item.id] = item
	  			console.log("Replacing item[" + idx + "]=" + item.id)
	  			state.savingId = null
	  		}
	  	})

	  	console.log("["+ firebaseNode +"] DATABASE SIZE => "+ state.firebaseData[firebaseNode].length)
	  	if (callback) {
	  		callback(state.firebaseData[firebaseNode]);
	  	}

    },
    updateCurrentPage: function(state, payload) {
    	let firebaseNode = payload.firebaseNode
    	let page = payload.page
    	if (state.dataPagination[firebaseNode] == null) {
	  		state.dataPagination[firebaseNode] = {currentPage: 0}
	  	}
		  state.dataPagination[firebaseNode].currentPage = page;
    },

		showAlert: function(state, show) {
			state.notification = show
    },
    removeItem: function(state, payload) {
    	let firebaseNode = payload.firebaseNode
    	let item = payload.item
    	let itemId = item.id
      const idx = state.firebaseData[firebaseNode].indexOf(item);
		  state.firebaseData[firebaseNode].splice(idx, 1);
		  const orgId = state.organization.id;
		  db.ref(`/${firebaseNode}/${orgId}`).child(itemId).set(null)
      .then(() => {
      	 state.searchIndex[firebaseNode].removeDocByRef(itemId)
         console.log(`REMOVED=/${firebaseNode}/${orgId}/${itemId}`)
      });
	},
	updatePublishingData: function(state, { type, publishing }) {
		if (publishing) {
			state.publishingStates[type] = true
		} else {
			delete state.publishingStates[type]
		}
	}
	},
	actions : {
		// pass to mutation
		updateFilter : function(context, filters){
			context.commit('updateFilter', filters);
		},

		processEntity : (context, payload) => {
		  console.log('calle dprocess entity')
		  let results = [];
		  let firebaseNode = payload.firebaseNode
			let orgId = payload.orgId
			let startAt = payload.startAt
			let callback = payload.callback
			let snapshot = payload.snapshot
			let addItemToSearch = payload.addItemToSearch
			let onLoadedCallback = payload.onLoadedCallback

		  let ct = 0, children = snapshot.numChildren();

		  snapshot.forEach(child => {
		    let item = child.val();
		    if (ct <= recordsPerPage - 1 || children <= recordsPerPage ) {
		      item.id = child.key
		      // add to search index
		      context.commit('addItemToSearch', {item: item, firebaseNode: firebaseNode})
		      results.push(item);
		    } else {
			  console.log(' called on the snapshot fetch entities')
		      context.dispatch('fetchEntities', {
		      	firebaseNode: firebaseNode,
		      	orgId: orgId,
		      	startAt: child.key,
		      	callback:callback,
		      	onLoadedCallback: onLoadedCallback,
		      	addItemToSearch: addItemToSearch
		      }  );
		    }
		    ct++;
		  });
		  context.commit('appendItems', {firebaseNode: firebaseNode, items: results, callback: callback})

		  if (children <= recordsPerPage) {
		  	context.commit('changeDataStatus', {firebaseNode: firebaseNode, status:"LOADED"})
		  	if (onLoadedCallback != null) {
		  		onLoadedCallback(firebaseNode)
		  	}
		  	console.log("["+ firebaseNode +"] LOADED ")
		  }

		},

		fetchEntities: (context, payload) => {
			let firebaseNode = payload.firebaseNode
			let orgId = payload.orgId
			let startAt = payload.startAt
			let callback = payload.callback
			let onLoadedCallback = payload.onLoadedCallback
			let addItemToSearch = payload.addItemToSearch
			console.log(`fetchEntities->/${firebaseNode}/${orgId}/${startAt}`)
			const query = db.ref(`/${firebaseNode}/${orgId}`);

		  if (context.state.firebaseData[firebaseNode] != null && !startAt) {
		  	console.log("["+ firebaseNode +"] USING CACHED DATA ==> "+ context.state.firebaseData[firebaseNode].length)
		  	callback(context.state.firebaseData[firebaseNode]);
		  	if (onLoadedCallback != null) {
		  		onLoadedCallback(firebaseNode)
		  	}
		  	return
		  }

		  if (context.state.firebaseDataStatus[firebaseNode] == 'LOADING' && !startAt) {
		  	context.commit('createDataCache', {firebaseNode: firebaseNode, callback: callback})
		  	return
		  }
		  context.commit('changeDataStatus', {firebaseNode: firebaseNode, status:"LOADING"})
		  if (startAt) {
		    // Recursive
		    console.log('recursive');
		 	  query.orderByKey().limitToFirst(recordsPerPage + 1).startAt(startAt).on('value', snapshot => {
				console.log('recursive inside')
		 	  	context.dispatch('processEntity', {firebaseNode: firebaseNode, orgId: orgId, snapshot: snapshot, callback: callback, addItemToSearch: addItemToSearch, onLoadedCallback:onLoadedCallback})
		    })
		  } else {
		    // First time
		    console.log('first time');
		    query.orderByKey().limitToFirst(recordsPerPage + 1).on('value', snapshot => {
		    		if (context.state.firebaseData[firebaseNode] == null) {
						console.log('first time inside')
			    		context.dispatch('processEntity',{firebaseNode: firebaseNode, orgId: orgId, snapshot: snapshot, callback: callback, addItemToSearch: addItemToSearch, onLoadedCallback:onLoadedCallback});
			    	}
		     })
		  }
		},
		fetchDatabase: (context, payload) => {
			let firebaseNode = payload.firebaseNode
			let onFetchCallback = payload.onFetchResult
			let onLoadedCallback = payload.onLoadedCallback

			const promises = []
      const promise = new Promise((resolve) => {
        resolve(context.state.organization)
      });
      promises.push(promise)

      if (context.getters.searchIndex(firebaseNode) == null) {
        console.log("["+ firebaseNode +"] CREATING SEARCH INDEX" )
        let searchPromise = context.commit('initSearchIndex', {firebaseNode: firebaseNode})
        promises.push(searchPromise)
      } else {
		  console.log('index exists')
	  }

      Promise.all(promises).then(values => {
		  console.log('called here')
      	context.dispatch('fetchEntities',
	        {
	          firebaseNode: firebaseNode,
	          orgId: context.state.organization.id,
	          startAt: false,
	          callback: onFetchCallback,
	          onLoadedCallback: onLoadedCallback
	        })
	      });
		},
		updateSearchText: (context, payload) => {
			context.commit('updateSearchText', payload)
		},
		updateSearchCriterion: (context, payload) => {
			context.commit('updateSearchCriterion', payload)
		},
		updatePublishingData: (context, payload) => {
			context.commit('updatePublishingData', payload)
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js